import * as types from '../constants/ActionTypes';

export const setAuth = authStatus => ({
  type: types.SET_AUTH,
  payload: authStatus,
});

export const removeAuth = () => ({
  type: types.REMOVE_AUTH,
});
